import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { ConsumerAuthForm } from "@/components/auth/ConsumerAuthForm";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/user/login")({
  head: () => ({
    meta: [
      { title: "Sign in · Pulse" },
      { name: "description", content: "Sign in to Pulse." },
    ],
  }),
  component: UserLoginPage,
});

function UserLoginPage() {
  const { user, hydrated, isGuest } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hydrated && user && !isGuest) {
      void navigate({ to: "/", replace: true });
    }
  }, [hydrated, user, isGuest, navigate]);

  return (
    <div className="relative flex min-h-screen items-center justify-center px-5 py-14">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-gradient-glow" />
      <div className="relative w-full max-w-md">
        <ConsumerAuthForm
          variant="page"
          onSuccess={() => {
            void navigate({ to: "/", replace: true });
          }}
        />
      </div>
    </div>
  );
}
